import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-auth-callback-base",
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: "",
})
export class AuthCallbackBaseComponent implements OnInit {
  private auth = inject(AuthService);
  private router = inject(Router);

  protected AUTH_SUCCESS_URL = "/";

  public async ngOnInit(): Promise<void> {
    try {
      await this.auth.redeemToken();
      this.router.navigate([this.AUTH_SUCCESS_URL]);
    } catch (error) {
      console.error(error);
    }
  }
}
